import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Plugins } from "@capacitor/core";
import config from "config.js";
import { isNativeIosPlatform } from "./deviceInfo";
const { App, Browser } = Plugins;

function AppUrlListener() {
  const history = useHistory();

  useEffect(() => {
    const listener = App.addListener("appUrlOpen", (data) => {
      let url;
      try {
        url = new URL(data.url);
      } catch (error) {
        return;
      }

      // Provider callbacks belong to their native plugins, not the app router.
      if (url.origin !== new URL(config.MYACCOUNT.ADDRESS).origin) {
        return;
      }

      let state = {};
      if (
        url.pathname.endsWith("/autopayment") &&
        url.searchParams.has("message")
      ) {
        let message;
        try {
          message = JSON.parse(url.searchParams.get("message"));
        } catch (error) {
          return;
        }
        if (!message) {
          return;
        }
        state = {
          result: url.searchParams.get("result"),
          cctoken: message.ssl_token,
        };
      }

      // UserSetUp exchanges legacy pi tokens; the provider chooser does not.
      if (
        url.pathname === config.MYACCOUNT.APP_PATH + "/login" &&
        url.searchParams.has("pi")
      ) {
        url.pathname = config.MYACCOUNT.APP_PATH + "/";
      }

      if (isNativeIosPlatform()) {
        // The legacy iOS redirect flow registers a browserFinished handler
        // that would otherwise navigate away from this universal-link route
        // as soon as the browser is closed.
        Browser.removeAllListeners();
      }
      Browser.close();

      history.push({
        pathname: url.pathname,
        search: url.search,
        hash: url.hash,
        state,
      });
      window.location.reload();
    });

    return () => listener.remove();
  }, [history]);

  return null;
}

export default AppUrlListener;
